import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { variables } from '../../assets/styles/variables';
import themeColors from '../../assets/styles/themeColors';

const AnchorStyles = styled.a`
  color: ${themeColors.colorTextSecondary};
  text-decoration: underline;
  font-weight: 600;
  font-size: ${variables.typography.p.regular.fontSize};
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : '10px')};
  text-decoration-color: ${themeColors.colorLink};
`;

const Anchor = (props) => {
  const { children } = props;

  return <AnchorStyles {...props}>{children}</AnchorStyles>;
};

Anchor.propTypes = {
  children: PropTypes.node,
};

export default Anchor;
